function normalizarTexto(valor) {
  if (valor == null) return ''
  if (Array.isArray(valor)) {
    return valor.filter((v) => v != null && v !== '').map(String).join(' ')
  }
  return String(valor)
}

function parseEntero(valor) {
  const texto = String(valor == null ? '' : valor).trim()
  if (!/^-?\d+$/.test(texto)) return null
  return {
    valor: Number(texto),
    esNegativoCero: texto === '-0',
  }
}

export function extraerTexto(textoOrigen, posicion, longitud) {
  const texto = normalizarTexto(textoOrigen)
  if (!texto) return ''

  const pos = parseEntero(posicion)
  const len = parseEntero(longitud)

  if (!pos || !len || len.valor === 0) return ''

  const indice = pos.esNegativoCero
    ? texto.length - 1
    : pos.valor >= 0
      ? pos.valor
      : texto.length - 1 - Math.abs(pos.valor)

  if (indice < 0 || indice >= texto.length) return ''

  if (len.valor > 0) {
    const fin = Math.min(texto.length, indice + len.valor)
    return texto.slice(indice, fin)
  }

  const inicio = Math.max(0, indice + len.valor + 1)
  return texto.slice(inicio, indice + 1)
}
